import camelcase from 'camelcase';
import { defaultSettings } from '../../settings';
import { VisibleColumns } from '../../types';

export const getHiddenColumns = (visibleColumns: VisibleColumns[]) => {
  if (visibleColumns.length === 0) {
    return defaultSettings.billingHistory.visibleColumns
      .filter((c) => c !== 'invoice_number')
      .map((c) => camelcase(c));
  }
  return defaultSettings.billingHistory.visibleColumns
    .filter((x) => !visibleColumns.includes(x))
    .map((c) => camelcase(c));
};
